import { UsersHeader, UsersTable } from '@pages/users/containers';
import { HasPermission } from '@shared/components';
import { FC } from 'react';

export const Users: FC = () => {
  return (
    <HasPermission permissionFeature="COMPANY_ACCOUNT_LIST_OF_USERS" permissionType="READ" redirect>
      <UsersHeader />
      <UsersTable />
    </HasPermission>
  );
};
